module.exports = __webpack_public_path__ + "4930d8137c0e47322a1b93d127bbfaac.svg";